var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.922,
    height: 12.98,
    viewBox: "0 0 12.922 12.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call",
    transform: "translate(0.099 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46218",
    "data-name": "Group 46218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13053",
    "data-name": "Path 13053",
    d: "M11.055,35.024a1.334,1.334,0,0,0-.968-.444,1.38,1.38,0,0,0-.979.441l-.9.9c-.074-.04-.149-.077-.22-.115-.1-.052-.2-.1-.283-.152A9.832,9.832,0,0,1,5.343,33.51a5.8,5.8,0,0,1-.773-1.22c.235-.215.452-.438.664-.653l.24-.243a1.313,1.313,0,0,0,0-1.981l-.782-.782c-.089-.089-.18-.18-.266-.272-.172-.177-.352-.361-.538-.532a1.355,1.355,0,0,0-.959-.421,1.4,1.4,0,0,0-.973.421l-.006.006-.973.982a2.094,2.094,0,0,0-.621,1.331A5.019,5.019,0,0,0,.723,32.27a12.326,12.326,0,0,0,2.19,3.653A13.472,13.472,0,0,0,7.4,39.436a6.99,6.99,0,0,0,2.519.744c.06,0,.123.006.18.006a2.157,2.157,0,0,0,1.652-.71c0-.006.009-.009.011-.014a6.508,6.508,0,0,1,.5-.518c.123-.117.249-.24.372-.369a1.428,1.428,0,0,0,.432-.991,1.376,1.376,0,0,0-.441-.982Zm1.025,3.015s0,0,0,0c-.112.12-.226.229-.349.349a7.529,7.529,0,0,0-.553.573,1.38,1.38,0,0,1-1.076.455c-.043,0-.089,0-.132,0a6.209,6.209,0,0,1-2.233-.67,12.717,12.717,0,0,1-4.226-3.309A11.623,11.623,0,0,1,1.45,32a4.088,4.088,0,0,1-.321-1.792,1.314,1.314,0,0,1,.4-.85l.976-.976a.651.651,0,0,1,.435-.2.612.612,0,0,1,.418.2l.009.009c.175.163.341.332.515.512l.272.278.782.782a.546.546,0,0,1,0,.887c-.083.083-.163.166-.246.246-.24.246-.47.475-.719.7-.006.006-.011.009-.014.014a.584.584,0,0,0-.149.65l.009.026a6.274,6.274,0,0,0,.925,1.509l0,0a10.508,10.508,0,0,0,2.542,2.313,3.909,3.909,0,0,0,.352.192c.1.052.2.1.283.152l.034.02a.621.621,0,0,0,.283.072.612.612,0,0,0,.435-.2l.979-.979a.648.648,0,0,1,.432-.215.583.583,0,0,1,.412.209l.006.006,1.577,1.577A.566.566,0,0,1,12.079,38.039Z",
    transform: "translate(-0.344 -27.406)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.090c2a8758ecbdece49a8f88e96e5ca2.svg";
export { ForwardRef as ReactComponent };